/* tslint:disable */
/* eslint-disable */
/**
 * AMONDZ-ADMIN-BACKEND-V2
 * AMONDZ-ADMIN-BACKEND-V2 API 문서입니다.
 *
 * The version of the OpenAPI document: 2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import { CouponFixedDateDto } from './coupon-fixed-date-dto';

/**
 *
 * @export
 * @interface CouponDto
 */
export interface CouponDto {
  /**
   * 쿠폰 식별 id
   * @type {number}
   * @memberof CouponDto
   */
  id: number;
  /**
   * 쿠폰 이름
   * @type {string}
   * @memberof CouponDto
   */
  name: string;
  /**
   * 쿠폰 적용 가능 범위( allProducts : 전체 상품 쿠폰 , targetProduct : 특정 상품 쿠폰 , targetStore : 특정 브랜드 쿠폰 )
   * @type {string}
   * @memberof CouponDto
   */
  availableType: CouponDtoAvailableTypeEnum;
  /**
   * 기간 타입( fixedDate : 날짜 지정 , generatedDate : 발급일 기준 , infinity : 무기한 )
   * @type {string}
   * @memberof CouponDto
   */
  periodType: CouponDtoPeriodTypeEnum;
  /**
   * 할인 타입( amount : 금액 , rate : 할인율 )
   * @type {string}
   * @memberof CouponDto
   */
  discountType: CouponDtoDiscountTypeEnum;
  /**
   * 할인 타입에 따른 혜택 수치(금액, 할인률 등)
   * @type {number}
   * @memberof CouponDto
   */
  discountAmount: number;
  /**
   * 쿠폰 다운로드 가능 여부
   * @type {boolean}
   * @memberof CouponDto
   */
  isDownloadable: boolean;
  /**
   * 쿠폰에 대한 설명
   * @type {string}
   * @memberof CouponDto
   */
  description: string;
  /**
   * 발급일로부터 날짜 수
   * @type {number}
   * @memberof CouponDto
   */
  dayPlus?: number;
  /**
   * 쿠폰 고유 코드
   * @type {string}
   * @memberof CouponDto
   */
  code: string;
  /**
   * 발급제한 기간 날짜 (0: 무제한, 1~ : 기간내에 몇회로 제한)
   * @type {number}
   * @memberof CouponDto
   */
  generateLimitDay?: number;
  /**
   * 발급제한 횟수
   * @type {number}
   * @memberof CouponDto
   */
  generateLimitCount?: number;
  /**
   * 쿠폰에 대한 메모 (구매자, 판매자에게는 노출되지 않고 운영자들이 간단히 남기는 내용)
   * @type {string}
   * @memberof CouponDto
   */
  memo: string;
  /**
   * 쿠폰 상태( inactive : 비활성 (노출 안함) , active : 활성 (노출 함) )
   * @type {string}
   * @memberof CouponDto
   */
  status: CouponDtoStatusEnum;
  /**
   * 쿠폰 생성 일자
   * @type {string}
   * @memberof CouponDto
   */
  createDate: string;
  /**
   * 쿠폰 수정 일자
   * @type {string}
   * @memberof CouponDto
   */
  updateDate: string;
  /**
   * 특정 브랜드 쿠폰의 24k상품 제외여부
   * @type {boolean}
   * @memberof CouponDto
   */
  exclude24k?: boolean;
  /**
   * 최소 구매 금액(원 단위)
   * @type {number}
   * @memberof CouponDto
   */
  minimumPurchaseAmount: number;
  /**
   * 최대 할인 가능 금액 (원 단위)
   * @type {number}
   * @memberof CouponDto
   */
  maximumDiscountAmount?: number;
  /**
   *
   * @type {CouponFixedDateDto}
   * @memberof CouponDto
   */
  date?: CouponFixedDateDto;
}

export const CouponDtoAvailableTypeEnum = {
  AllProducts: 'allProducts',
  TargetProduct: 'targetProduct',
  TargetStore: 'targetStore',
} as const;

export type CouponDtoAvailableTypeEnum = (typeof CouponDtoAvailableTypeEnum)[keyof typeof CouponDtoAvailableTypeEnum];
export const CouponDtoPeriodTypeEnum = {
  FixedDate: 'fixedDate',
  GeneratedDate: 'generatedDate',
  Infinity: 'infinity',
} as const;

export type CouponDtoPeriodTypeEnum = (typeof CouponDtoPeriodTypeEnum)[keyof typeof CouponDtoPeriodTypeEnum];
export const CouponDtoDiscountTypeEnum = {
  Amount: 'amount',
  Rate: 'rate',
} as const;

export type CouponDtoDiscountTypeEnum = (typeof CouponDtoDiscountTypeEnum)[keyof typeof CouponDtoDiscountTypeEnum];
export const CouponDtoStatusEnum = {
  Inactive: 'inactive',
  Active: 'active',
} as const;

export type CouponDtoStatusEnum = (typeof CouponDtoStatusEnum)[keyof typeof CouponDtoStatusEnum];
